import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import './App.css';
import Header from './components/Header';
import Home from './pages/Home';
import DevOps from './pages/DevOps';
import Cloud from './pages/Cloud';
import DataScience from './pages/DataScience';
import DataEngineering from './pages/DataEngineering';
import GenerativeAI from './pages/GenerativeAI';
import AppDevelopment from './pages/AppDevelopment';
import Contact from './pages/Contact';

function ScrollToTop() {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <ScrollToTop />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/devops" element={<DevOps />} />
            <Route path="/cloud" element={<Cloud />} />
            <Route path="/data-science" element={<DataScience />} />
            <Route path="/data-engineering" element={<DataEngineering />} />
            <Route path="/generative-ai" element={<GenerativeAI />} />
            <Route path="/app-development" element={<AppDevelopment />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
